export const orgs = [
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/24kick.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/antibeili.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/aomei.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/b-monster.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/baolihao.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/chaojixingxing.jpg',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/diyitiyu.png',
  // 'http://imgcdn.lanxiongsports.com/upload/0421/dingshangjianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/feiyou.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/fengkuangyundong.png',
  // 'http://imgcdn.lanxiongsports.com/upload/shape/0420/ge.png',
  // 'http://imgcdn.lanxiongsports.com/upload/shape/0420/gongyuanhezi.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/gudefeili.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/guangzhuquan.jpg',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/haoshajianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/huangjinshidai.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/hyperfit.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/jianshenzhe.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/jiayoujianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/jieshidongneng2.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/jinjiniao.png',
  // 'http://imgcdn.lanxiongsports.com/upload/shape/0420/jipaoba.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/jumpfit.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/k-ems.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/keepland.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/kuaikuaijianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/lekeyundong.jpg',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/lianyujianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/likingfit.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/limeijian.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/meigefeijianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/mofangyundong.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/pure.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/qijijianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/qingniaojianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/qingchengjianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/renmajun.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/renmaxian.png',
  // 'http://imgcdn.lanxiongsports.com/upload/shape/0420/saipujianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/shape2.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/shushibao.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/spacecycle.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/weiershi.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/xingzhijianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/xone.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/yijianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/lanxiong/yijiasijiao.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/yingpaisi.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/yinjimu.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/yinligongchang.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/yizhaoweide.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/zespeed.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/zhonghangjianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/0422/zhongjianjianshen.png',
  'http://imgcdn.lanxiongsports.com/upload/shape/0420/zhongtibeili.png',
  'http://imgcdn.lanxiongsports.com/upload/0421/ziyouzhe2.png'
]
